import { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import { useParams, useHistory } from 'react-router-dom';
import { Tooltip, IconButton, CircularProgress, Alert } from '@mui/material';
import { ArrowBack, Replay, FileDownloadOutlined } from '@mui/icons-material';
import { api } from "../../services/api";
import { config } from '../../services/config';
import Loading from '../../components/Loading';
import { useTranslation } from 'react-i18next';
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";

const apiOrigin = config.URL_API;

const Voucher = () => {
  const history = useHistory();
  const param = useParams();
  console.log("Params:", param);
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null
  });
  const [data, setData] = useState();
  const [updating, setUpdating] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [t] = useTranslation("global");

  useEffect(() => {
    const callApi = async () => {
      try {
        const response = await api.vouchers.getVoucherById(param.idvoucher);
        if (response.status === "success") {
          console.log("response", response)
          const res = response.data.voucher;
          setData(res);
        }
      } catch (error) {
        setState({
          ...state,
          error: "Error en la Red.",
        });
      }
    };
    callApi();
  }, []);

  const handleUpdateImage = async () => {
    try {
      setUpdating(true);
      const idevento = data?.idevento;
      if (!idevento) {
        alert("No se pudo obtener el evento del voucher");
        return;
      }

      const response = await api.vouchers.updateVoucherImage(idevento, param.idvoucher);
      if (response.status === "success") {
        const img = document.querySelector(`img[alt="Imagen del voucher"]`);
        if (img) {
          const timestamp = new Date().getTime();
          img.src = `${apiOrigin}/static/eventos/vouchers/voucher${param.idvoucher}.png?t=${timestamp}`;
        }
        alert("Imagen actualizada correctamente");
      }
    } catch (error) {
      console.error("Error actualizando imagen:", error);
      alert("Error al actualizar la imagen");
    } finally {
      setUpdating(false);
    }
  };

  const handleDownload = async () => {
    if (!data?.id) return;
    try {
      setDownloading(true);
      const response = await fetch(`${apiOrigin}/api/vouchers/download/${data.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) throw new Error('Error al descargar');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const eventoNombre = data?.tarifa?.evento?.evento || 'evento';
      const voucherTipo = data?.tarifa?.concepto || 'voucher';
      const fileName = `${eventoNombre.replace(/\s+/g, '_')}_${voucherTipo.replace(/\s+/g, '_')}_${data.id}.pdf`;

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading voucher PDF:", error);
      alert("Error al descargar el voucher. Por favor, inténtalo de nuevo más tarde.");
    } finally {
      setDownloading(false);
    }
  };

  const routeImage = `${apiOrigin}/static/eventos/vouchers/voucher${param.idvoucher}.png`;

  const imageStyle = {
    width: window.innerWidth > 880 ? "400px" : "100%",
    maxWidth: "100%"
  };

  return (
    <div style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
      <div className="d-flex flex-row justify-content-between"
        style={{
          backgroundColor: "white",
          borderTop: "1px solid #E4E4E7",
          borderBottom: "1px solid #E4E4E7",
          padding: "10px"
        }}>
        <button type="button" onClick={() => history.goBack()}>
          <ArrowBack />
        </button>
        <div className='d-flex flex-row align-items-center gap-4'>
          <p className='mb-0' style={{ fontWeight: "600" }}>
            {data?.tarifa?.evento?.evento || "Cargando..."}
          </p>
          <span style={{ borderRight: "1px solid #e4e4e7", height: "100%" }}></span>
          <p className='mb-0'>
            Voucher ID: <span style={{ fontWeight: "600" }}>{data?.id}</span>
          </p>
        </div>
      </div>

      {/* Contenido Principal */}
      <div style={{
        backgroundColor: "white",
        padding: "10px 40px",
        margin: "30px",
        borderRadius: "10px",
        border: "1px solid #e4e4e7"
      }}>
        <div className='d-flex flex-row justify-content-between align-items-center my-3'>
          <p className='mb-0' style={{
            fontSize: "18px",
            color: "#5656FF",
            fontWeight: "600"
          }}>
            Vista previa del voucher
          </p>
          <div className='d-flex flex-row gap-2'>
            <button
              type="button"
              onClick={handleDownload}
              style={{
                color: "#5656FF",
                borderRadius: "50%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: downloading ? 0.7 : 1
              }}
              disabled={downloading}
            >
              {downloading ? (
                <cIRCULARpr size={18} sx={{ color: '#5656FF' }} />
              ) : (
                <Tooltip title="Descargar voucher" arrow>
                  <IconButton><FileDownloadOutlined /></IconButton>
                </Tooltip>
              )}
            </button>
            <button
              type="button"
              onClick={handleUpdateImage}
              disabled={updating}
            >
              <Tooltip title="Actualizar diseño del voucher" arrow>
                <IconButton disabled={updating}>
                  {updating ? <CircularProgress size={20} /> : <Replay />}
                </IconButton>
              </Tooltip>
            </button>
          </div>
        </div>

        <div style={{
          borderRadius: "10px",
          border: "1px solid #e4e4e7"
        }}>
          <div className='d-flex justify-content-center'>
            {data ? (
              <img
                src={routeImage}
                alt='Imagen del voucher'
                style={imageStyle}
                onError={(e) => {
                  e.target.src = '/static/design-not-available.png';
                }}
              />
            ) : (
              <CircularProgress />
            )}
          </div>
        </div>

        <div style={{
          borderTop: "1px solid #e4e4e7",
          marginTop: "40px",
          paddingTop: "40px"
        }}>
          <div className="d-flex flex-row gap-2"
            style={{
              padding: "25px 0 10px",
              borderBottom: "1px solid #e4e4e7"
            }}>
            <p style={{
              fontSize: "18px",
              color: "#5656FF",
              fontWeight: "600",
              marginBottom: "0"
            }}>
              Detalles del Voucher
            </p>
          </div>

          {data ? (
            <div style={{ marginTop: "20px" }}>
              <div className='d-flex flex-row gap-5'>
                <div className='d-flex flex-column'>
                  <p className='mb-0' style={{
                    fontWeight: "400",
                    color: "#6B7280",
                    lineHeight: "14px",
                    fontSize: "14px"
                  }}>
                    Nombre
                  </p>
                  <p className='mb-0' style={{ fontWeight: "500" }}>
                    {data.nombre}
                  </p>
                  <div style={{ marginTop: "15px" }}>
                    <p className='mb-0' style={{
                      fontWeight: "400",
                      color: "#6B7280",
                      lineHeight: "14px",
                      fontSize: "14px"
                    }}>
                      Tarifa
                    </p>
                    <p className='mb-0' style={{ fontWeight: "500" }}>
                      {data.tarifa?.concepto}
                    </p>
                  </div>
                  <div style={{ marginTop: "15px" }}>
                    <p className='mb-0' style={{
                      fontWeight: "400",
                      color: "#6B7280",
                      lineHeight: "14px",
                      fontSize: "14px"
                    }}>
                      Cantidad
                    </p>
                    <p className='mb-0' style={{ fontWeight: "500" }}>
                      {data.cantidad}
                    </p>
                  </div>
                </div>
                <div className='d-flex flex-column'>
                  <p className='mb-0' style={{
                    fontWeight: "400",
                    color: "#6B7280",
                    lineHeight: "14px",
                    fontSize: "14px"
                  }}>
                    Apellido
                  </p>
                  <p className='mb-0' style={{ fontWeight: "500" }}>
                    {data.apellido}
                  </p>
                  <div style={{ marginTop: "15px" }}>
                    <p className='mb-0' style={{
                      fontWeight: "400",
                      color: "#6B7280",
                      lineHeight: "14px",
                      fontSize: "14px"
                    }}>
                      Importe
                    </p>
                    <p className='mb-0' style={{ fontWeight: "500" }}>
                      ${data.importe}
                    </p>
                  </div>
                </div>
              </div>
              <div style={{
                marginTop: "20px",
                padding: "20px 0 10px",
                borderTop: "1px solid #e4e4e7"
              }}>
                <p className='mb-0' style={{
                  fontWeight: "300",
                  color: "#6B7280",
                  lineHeight: "14px",
                  fontSize: "14px"
                }}>
                  Este voucher es personal e intransferible.
                </p>
              </div>
            </div>
          ) : (
            <Alert severity="info">
              Hubo un error en la obtención del voucher. Por favor comuníquese con el desarrollador.
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Voucher, {
  onRedirecting: () => <Loading />,
});